import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import HomepageCampaignViewModel from '@app/models/homepage-campaign-view-model';
import { Observable } from 'rxjs';

import { Campaign, HomepageCampaign } from '../models';

@Injectable()
export class ContentService {
  constructor(private http: HttpClient) {}

  /**
   * Gets homepage campaigns from the API that are currently active
   */
  getHomepageCampaigns() {
    console.log('ContentService.getHomepageCampaigns');
    return this.http.get<HomepageCampaign[]>('content/homepageCampaigns/');
  }

  /**
   * Gets homepage campaigns from the API. Unfiltered, so past and future homepage campaigns will be returned
   */
  getAllHomepageCampaigns() {
    console.log('ContentService.getHomepageCampaigns');
    return this.http.get<HomepageCampaignViewModel[]>('content/homepageCampaigns/all');
  }

  /**
   * Saves the Homepage Campaign
   * @param c the campaign object to be saved
   */
  saveHomepageCampaign(c: HomepageCampaign) {
    return this.http.post<HomepageCampaign>('content/homepageCampaigns/SaveHomepageCampaign', c);
  }

  /**
   * Deletes the campaign
   * @param c the campaign to be deleted
   */
  deleteHomepageCampaign(id: number) {
    return this.http.delete(`content/homepageCampaigns/DeleteHomepageCampaign/${id}`);
  }

  getCampaignContent(campaignTag: string): Observable<Campaign> {
    return this.http.get<Campaign>(`content/campaign/${campaignTag}`);
  }

  /**
   * Manually refreshes the listing cache in order to refresh in between the hourly refresh.
   */
  refreshListingSearchCache() {
    return this.http.get('admin/listings/cache/refresh');
  }

  getCampaigns() {
    return this.http.get<Campaign[]>('campaigns/');
  }
  addCampaign(c: Campaign) {
    return this.http.post('campaigns/', c);
  }
  removeCampaign(c: Campaign) {
    return this.http.delete(`campaigns/${c.campaignTag}`);
  }
}
